import { importProvidersFrom, isDevMode } from '@angular/core';
import { AppComponent } from './app/app.component';
import { AppRoutingModule } from './app/app-routing.module';
import { LayoutModule } from './app/layout/layout.module';
import { CoreModule } from './app/core/core.module';
import { appConfig } from './app/core/config/app.config';
import { FuseConfigModule } from '@fuse/services/config';
import { FuseModule } from 'src/@fuse';
import { withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { IonicRouteStrategy, IonicModule } from '@ionic/angular';
import { RouteReuseStrategy } from '@angular/router';
import { TranslocoHttpLoader } from './app/core/transloco/transloco.http-loader';
import { provideTransloco } from '@jsverse/transloco';

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      IonicModule.forRoot({
        backButtonText: '',
        backButtonIcon: 'chevron-back',
      }),
      // Fuse, FuseConfig & FuseMockAPI
      FuseModule,
      FuseConfigModule.forRoot(appConfig),
      // FuseMockApiModule.forRoot(mockApiServices),
      // Core module of your application
      CoreModule,
      // Layout module of your application
      LayoutModule,
      AppRoutingModule,
    ),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideHttpClient(), 
    provideTransloco({
        config: { 
          availableLangs: ['en', 'es'],
          defaultLang: 'en',
          // Remove this option if your application doesn't support changing language in runtime.
          reRenderOnLangChange: true,
          prodMode: !isDevMode(),
        },
        loader: TranslocoHttpLoader
      }),
  ],
}).catch((err) => console.error(err));
